import { Document, Font, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import extenso from 'extenso';
import { currencyOf } from 'utils/util';

export type ComprovanteSangriaProps = {
    caixa: string;
    valor: number;
    conta: string | undefined;
    motivo: string | undefined;
    usuario: string;
    dataHora: string;
};

Font.register({
    family: "Anton",
    src: "/assets/fonts/anton.ttf",
});

const s = StyleSheet.create({
    page: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '25px 7px',
    },
    title: {
        fontSize: '11px',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        marginBottom: '10px',
    },
    text1: {
        fontSize: '10',
        width: '40%',
    },
    text2: {
        fontSize: '10',
        width: '60%',
    },
    textWrapper: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },

});

const ComprovanteSangria = (props: ComprovanteSangriaProps) => {
    return (
        <Document
            title='Comprovante de sangria'
            author={props.usuario}
            language='pt-BR'
        >
            <Page
                size={'A7'}
                orientation='portrait'
                wrap={false}
                style={s.page}
            >
                <Text style={s.title}>Comprovante de saída de caixa</Text>
                <View style={s.textWrapper}>
                    <Text style={s.text1}>Caixa:</Text>
                    <Text style={s.text2}>{props.caixa}</Text>
                </View>

                <View style={s.textWrapper}>
                    <Text style={s.text1}>Valor:</Text>
                    <Text style={s.text2}>{currencyOf(props.valor)} ({extenso('' + props.valor, { mode: 'currency', number: { decimalSeparator: 'dot' } })})</Text>
                </View>

                <View style={s.textWrapper}>
                    <Text style={s.text1}>Conta:</Text>
                    <Text style={s.text2}>{props.conta}</Text>
                </View>

                <View style={s.textWrapper}>
                    <Text style={s.text1}>Referente à:</Text>
                    <Text style={s.text2}>{props.motivo}</Text>
                </View>

                <View style={s.textWrapper}>
                    <Text style={s.text1}>Realizado por:</Text>
                    <Text style={s.text2}>{props.usuario}</Text>
                </View>

                <View style={s.textWrapper}>
                    <Text style={s.text1}>Data:</Text>
                    <Text style={s.text2}>{props.dataHora}</Text>
                </View>

                <View style={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    borderTop: '1px',
                    borderStyle: 'dashed',
                    marginTop: '25px'
                }}>
                    <Text style={{
                        fontSize: 10,
                        textAlign: 'center',
                    }}
                    >(Assinatura do responsável)</Text>
                </View>
            </Page>
        </Document>

    );
};

export default ComprovanteSangria;
